// Меню
import * as LockScroll from './LockScroll.js';

let $menu = $('.js-menu'),
    $pageWrap = $('.js-page-wrap'),
    $menuClose = $('.js-menu-close'),
    $pageFrame = $('.js-page-frame'),
    $mobileHeader = $('.js-mobile-header');
    //$header = $('.js-header');



function closeMenu () {
    App.H.removeClass('_popup-menu');
    $menu.removeClass('_open');
    $pageWrap.removeClass('_scaled');
    $pageFrame.removeClass('_visible');
    $mobileHeader.removeClass('_visible');
    // $header.removeClass('_abs').css({'top': 0});
    App.menuIsOpen = false;
    LockScroll.unlock();

    if (App.H.hasClass('safari')) {
        App.W.resize();
    }
}


$('.js-clear-search').on('click', function (e) {
    $(this).closest('form').find('input[type="text"]').val('');

    e.preventDefault();
});


// Скролл меню
/*if (!App.mobile) {
    $('.js-menu-inner').mCustomScrollbar({
        'scrollInertia': 50
    });
} else {
    $('.js-menu-inner').addClass('_mobile-flex');
}*/

if (App.mobile) {
    $('.js-menu-inner').addClass('_mobile-flex');
}



// Вложенное меню
$('.js-submenu-toggler').on('click', function (e) {
    e.preventDefault();

    let $link = $(this),
        $parent = $link.closest('.js-submenu-wrap'),
        $submenu = $parent.find('.js-submenu');

    if ($parent.hasClass('_open')) {
        $parent.removeClass('_open');
        $submenu.slideUp(500);
    } else {
        $parent.addClass('_open');
        $submenu.slideDown(500);
    }
});


$('.js-submenu-wrap li a').on('click', function () {
    closeMenu();
});


// Бургер
$('.js-burger').on('click', function (e) {
    e.preventDefault();



    let top = App.W.scrollTop(),
        center = top + App.W.height() / 2;

    App.H.addClass('_popup-menu');
    // $header.addClass('_abs');
    $menu.addClass('_open');
    $pageFrame.addClass('_visible');
    $mobileHeader.addClass('_visible');
    App.menuIsOpen = true;


    // $header.css({'top': top + 'px'});
    $pageWrap
        .removeAttr('style')
        .css({
            'transform-origin': '50% ' + center + 'px',
            '-webkit-transform-origin': '50% ' + center + 'px'
        });

    $pageWrap.addClass('_scaled');
    LockScroll.lock();
});



// Крестик закрытия меню
$menuClose.on('click', function (e) {
    e.preventDefault();
    closeMenu();
});



// Закрытие меню при клике по контенту
/*$('.js-close-frame').on('click', function () {
    if (!App.H.hasClass('_disclaimer')) {
        closeMenu();
    }
});*/

App.D.on('mouseup', function(e) {
    if (App.desktop && !$menu.is(e.target) && $menu.has(e.target).length === 0) {
        closeMenu();
    }
});



// Крестик в мобильной версии
$('.js-mobile-menu-close').on('click', function (e) {
    e.preventDefault();
    closeMenu();
    $('.js-trader-screen').removeClass('_active');
    $menu.removeClass('_hidden');
    $mobileHeader.removeClass('_trader');
    LockScroll.unlock();
});


/* Костыль для IE11. При клике по кнопкам «Вперёд» и «Назад»
    он показывает html из кэша с уже открытым меню,
    поэтому нужно закрыть его принудительно */
if (App.H.hasClass('ie')) {
    $('.js-menu-inner a').on('click', function (e) {
        e.preventDefault();

        if (!$(this).hasClass('js-submenu-toggler')) {
            let href = $(this).attr('href');
            closeMenu();
            window.location = href;
        }
    });
}



// WEBPACK FOOTER //
// ./_src/js/modules/Menu.js